/** localStorage key for the Time grid's collapsed projects (per browser). */
const COLLAPSED_PROJECTS_KEY = "ed.time.collapsedProjects";

/** The projects this browser last collapsed in the grid. Blocked or bad storage reads none. */
export function readCollapsedProjects(): Set<string> {
  try {
    const raw = globalThis.localStorage?.getItem(COLLAPSED_PROJECTS_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(parsed) ? parsed.filter((x) => typeof x === "string") : []);
  } catch {
    return new Set();
  }
}

/** Remember the collapsed projects; a private window or blocked storage just doesn't. */
export function writeCollapsedProjects(keys: Set<string>): void {
  try {
    globalThis.localStorage?.setItem(COLLAPSED_PROJECTS_KEY, JSON.stringify([...keys]));
  } catch {
    // Storage unavailable: the choice lasts for this page view only.
  }
}

/**
 * What Collapse all / Expand all shows. A project holding a value that did not save stays open
 * whatever its setting, so it counts as open; `stuckOpen` is when only such projects are open,
 * so Collapse all would change nothing.
 */
export function toggleAllState(
  shown: string[],
  collapsed: ReadonlySet<string>,
  held: string[],
): { anyOpen: boolean; stuckOpen: boolean } {
  const anyOpen = shown.some((key) => !collapsed.has(key) || held.includes(key));
  return { anyOpen, stuckOpen: anyOpen && shown.every((key) => collapsed.has(key)) };
}

/**
 * Expand all or Collapse all over the shown projects. Projects hidden by the search or absent
 * from this week keep their state, so a filtered Expand all forgets nothing else.
 */
export function setProjectsOpen(
  collapsed: ReadonlySet<string>,
  shown: string[],
  open: boolean,
): Set<string> {
  const next = new Set(collapsed);
  for (const key of shown) {
    if (open) next.delete(key);
    else next.add(key);
  }
  return next;
}
